import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './tiptap.css'; 
import App from './App.tsx'
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense("Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxccHRdRWVdVkNyX0ZWZ0g=");

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
